import { Link } from '@remix-run/react'
import { appName } from '#app/utils/constants.ts'
import { cn } from '#app/utils/tailwind-merge.js'
import iconDark from './icon-dark.svg'
import icon from './icon.svg'
import wordmarkDark from './wordmark-dark.svg'
import wordmark from './wordmark.svg'

type LogoVariant = `light` | `dark`

const Logo = ({
	className,
	variant = `light`,
}: {
	className?: string
	variant?: LogoVariant
}) => {
	const isDark = variant === `dark`
	const iconSrc = isDark ? iconDark : icon
	const wordmarkSrc = isDark ? wordmarkDark : wordmark

	return (
		<Link
			to="/"
			className={cn(
				`flex items-center gap-3 rounded-md bg-gradient-to-b from-muted-500 to-muted-900 bg-clip-text text-center text-fluid-xl font-bold leading-snug text-transparent`,
				className,
			)}
		>
			<img
				src={iconSrc}
				alt="We Love Night Owl Logo"
				className="h-14 w-14 rounded-full"
			/>
			{` `}
			<span className="hidden lowercase text-brand-white sm:inline">
				<img src={wordmarkSrc} alt={appName} className="h-8" />
			</span>
		</Link>
	)
}
export { Logo }
